export const USER_TYPE = {
  ALL: 'all',
  BUYER: 'buyer',
  SELLER: 'seller',
};
